import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation CreateTrack($input: CreateTrackInput!) {
      createTrack(input: $input) {
        id
        image
        logo
        image_id
        twitter_image_id
        facebook_image_id
        facebook_image
        twitter_image
        logo_id
        name
        short_name
        street
        state
        city
        zipcode
        phone
        website
        schedule
        type_id
        size
        bio
        twitter
        facebook
        instagram
        youtube
        tiktok
        added_by
        type {
          id
          key
          value
        }
        poc {
          id
        }
        hasLiked
        faqs {
          id
          question
          answer
        }
        status
        timezone
        fullAddress
        chart_id
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      createTrack: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
          })
        );
      },
    }),
  }
);
